module.exports = __webpack_public_path__ + "img/img_aviodPhoney_01.9260047d.jpg";